import React, { useState } from "react";
import styled from "styled-components";
import BySource from "./Trials/bySource"
import BySourceWithRegion from "./Trials/bySourceWithRegion"

function TrialSignUpsWithRegionExplorer() {
  const [searchBy, setSearchBy] = useState("dd"); // 'week' or 'dd'
  const currentDateLabel = searchBy === "dd" ? "Daily" : "Weekly";
  const inverseDateLabel = searchBy === "dd" ? "Weekly" : "Daily";

  const handleChangeTimeFrame = () => {
    setSearchBy(searchBy === "dd" ? "week" : "dd");
  };

  return (
    <Container>
      <h1>
        New Sign-ups only with trial
      </h1>
      <div>
        <label>Current Time Frame:</label>&nbsp;
        <span style={{ fontSize: "1.2rem" }}>{currentDateLabel}</span> &nbsp;
        <button onClick={handleChangeTimeFrame}>Change to {inverseDateLabel}</button>
      </div>
      <br />
      <h2>{currentDateLabel} by Source</h2>
      <BySource date={searchBy} />
      <hr />

      <br />
      <h2>{currentDateLabel} by Source with Region</h2>
      <BySourceWithRegion date={searchBy} />
      <hr />
    </Container>
  );
}

const Container = styled.div`
  width: 80%;
  margin:24px auto;
  .iReLkr .ReactTable * {
    text-align:left
  }
`;


export default TrialSignUpsWithRegionExplorer;